module.exports = __webpack_public_path__ + "img/dp-sy-lm3.abc6fc2d.png";